import React from 'react';
import { Typography } from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ spacing, typography }) => ({
    root: {},
    givingInstructionsTitle: {
        fontWeight: typography.fontWeightBold,
    },
    givingMethodTitle: {
        marginTop: spacing(2),
        fontWeight: typography.fontWeightBold,
    },
    givingMethodBullettedList: {
        margin: [[0, 0, 0, spacing(2)]],
        wordWrap: 'break-word',
    },
}));

function HongKongTraditionalChineseGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_hong_kong`,
        classes.root,
    );

    const givingMethodTitleClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_title`,
        classes.givingMethodTitle,
    );

    const givingMethodBullettedListClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_bulleted_list`,
        classes.givingMethodBullettedList,
    );

    return (
        <div className={rootClassNames}>
            <Typography
                // eslint-disable-next-line max-len
                className={ClassNames(classes.givingInstructionsTitle, `${BEM_BLOCK_NAME}--giving_instructions_title`)}
                component="div"
                variant="body1"
            >
                {`「${campaignName}」奉獻方式`}
            </Typography>

            <div className={givingMethodTitleClassNames}>1. 現金或支票</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>{`請將現金或支票捐款放入「${campaignName}」奉獻封內`}</li>
                <li>請在支票抬頭寫 「馬鞍峰香港教會有限公司」</li>
                <li>請在奉獻封上填上你的英文全名（需與香港身份證上的姓名相同）、電話號碼及電郵地址</li>
                <li>如需要奉獻收據，也請填上你的通訊地址</li>
            </ul>

            <div className={givingMethodTitleClassNames}>2. FPS 轉數快</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>教會FPS 電話號碼 57410041</li>
                <li>{`請於付款前在留言/參考欄寫上「${campaignName}」、你的英文全名（需與香港身份證上的姓名相同）、電話號碼及電郵地址`}</li>
                <li>
                    請截圖「成功付款」的頁面傳送給會計部電郵：
                    <a href="mailto:ACTeam@saddleback.hk">ACTeam@saddleback.hk</a>
                    {'\u00a0'}
                    或 whatsapps: 57410041
                </li>
                <li>如需要奉獻收據，請提供你的通訊地址給會計部</li>
            </ul>

            <div className={givingMethodTitleClassNames}>3. PayMe</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>
                    掃描 PayMe 二維碼或使用以下連結
                    {'\u00a0'}
                    <a href="https://qr.payme.hsbc.com.hk/2/U4aE6ai3LTTx6mw5PdRoCF">https://qr.payme.hsbc.com.hk/2/U4aE6ai3LTTx6mw5PdRoCF</a>
                </li>
                <li>{`請於付款前在留言/參考欄寫上「${campaignName}」、你的英文全名（需與香港身份證上的姓名相同）、電話號碼及電郵地址`}</li>
                <li>
                    請截圖「成功付款」的頁面傳送給會計部電郵：
                    <a href="mailto:ACTeam@saddleback.hk">ACTeam@saddleback.hk</a>
                    {'\u00a0'}
                    或 whatsapps: 57410041
                </li>
                <li>如需要奉獻收據，請提供你的通訊地址給會計部</li>
            </ul>
        </div>
    );
}

export default HongKongTraditionalChineseGivingInstructions;
